module.exports = __webpack_public_path__ + "img/table.2045d788.png";